export const STYLE = {
  bodyBackgroundColor: '#fafafb',
  bodyColor: '',
  themeBackgroundColor: '#0FB8C9',
  themeColor: '#ffffff',
  headerBackgroundColor: '#0FB8C9',
  headerColor: '#ffffff',
  errorColor: '',
  successColor: '',
  card: {
    padding: '',
    backgroundColor: '',
  },
};

export const docId = 'paytmCheckoutScript';
